import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IEditorProps } from '.';
import { ToolbarGroups } from '../../../components/Editor/config/registry';

export const generate = (
  props?: Partial<IComponentSchema<IEditorProps>>
): IComponentSchema<IEditorProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Editor',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Editor,
    'x-component-props': {
      initialValue: '',
      disabled: false,
      visible: true,
      height: undefined,
      placeholder: '',
      menubar: false,
      statusbar: false,
      branding: false,
      toolbarGroups: [
        ToolbarGroups.History,
        ToolbarGroups.Formatting,
        ToolbarGroups.Lists,
        ToolbarGroups.Table,
      ],
      previewMode: false,
      templateEnabled: false,
      templateVisible: true,
      templateId: undefined,
      templateDataMapping: '',
    },
    'x-component-props-config': {},
  };
};
